import { coerceArray } from '@angular/cdk/coercion';
import { find } from 'lodash';
import { FeatureToggleModele } from '../../core/modeles/feature-toggle.modele';
import { FeatureDecisionService } from '../services/feature-decision/feature-decision.service';
import { BaseCondition } from './base-condition';

export class ToggleCondition implements BaseCondition {
  private desiredFeatures: Array<FeatureToggleModele> = [];

  constructor(desiredFeatures: FeatureToggleModele | Array<FeatureToggleModele>) {
    this.desiredFeatures = coerceArray(desiredFeatures);
  }

  isAllowed(service: FeatureDecisionService): boolean {
    return this.desiredFeatures.length > 0 && this.desiredFeatures.some(desired => find(service.features, desired));
  }
}
